import { useGetSwimmers } from "../services/swimmerService";
import { usePaginatedResource } from "../../../shared/hooks/usePaginatedResource";
import { DEFAULT_PAGE_SIZE } from "../../../shared/constants/pagination";
import { useAuthStore } from "../../../store";

export const useSwimmersResource = () => {
  const { user } = useAuthStore();
  const buildingId = user?.buildingId;
  const lifeguardId = user?.id;
  const {
    page,
    pageSize,
    filters,
    debouncedFilters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    resetFilters,
  } = usePaginatedResource({
    initialFilters: {
      swimmer_name: "",
    },
    initialPageSize: DEFAULT_PAGE_SIZE,
  });

  const {
    data: swimmers,
    isLoading,
    isError,
    refetch,
  } = useGetSwimmers({
    page,
    page_size: pageSize,
    swimmer_name: debouncedFilters.swimmer_name || undefined,
    // Always apply building_id and lifeguard_id from user context
    // These cannot be changed by the user via filters
    building_id: buildingId || undefined,
    lifeguard_id: lifeguardId || undefined,
  });

  return {
    data: swimmers,
    isLoading,
    isError,
    page,
    pageSize,
    filters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    resetFilters,
    refetch,
  };
};
